import { Component, OnInit, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import * as Models from '../../../../../../src/app/models/commonModels';
import { AldFormBaseComponent } from '../../../../../../src/app/shared/components/form/ald-form.component';
import { AuthenticationService } from '../../../../../../src/app/shared/services/authentication.service';
import { EnvironmentService } from '../../../../../../src/app/services/environment.service';
import { HelperService } from "../../../../../../src/app/services/helper/helper.service";
import { BannerService } from '../../../../../../src/app/shared/services/banner.service';

import { SettingsState } from '../../../../../../src/app/services/settings/settings.state';
import * as SettingsAction from '../../../../../../src/app/services/settings/settings.action';

import { User } from '../../../../../../src/app/models/user/user';

import { SettingsPreview } from '../../../../../../src/app/models/settings/settings';

import * as TyreOrderModels from '../../../../../../src/app/models/tyre-order/tyre-order';
import { AldState } from "../../../../../../src/app/services/ald/ald.state";
import * as AldActions from "../../../../../../src/app/services/ald/ald.action";
import * as GarageVisitsModels from '../../../../../../src/app/models/garage-visits/garage-visits';

@Component({
    selector: 'app-tyre-orders',
  templateUrl: './tyre-orders.component.html',
  styleUrls: ['./tyre-orders.component.css']
})

export class TyreOrdersComponent extends AldFormBaseComponent implements OnInit {


  public requestGet: Models.RequestModel = null;

  public orders: TyreOrderModels.TyreOrderModel[];

  public requestGarageVisitRequest: Models.Request<TyreOrderModels.TyreOrderModel> = new Models.Request<TyreOrderModels.TyreOrderModel>();


  @Select(AldState.TyreOrders)
  TyreOrders$: Observable<Models.ResponseList<TyreOrderModels.TyreOrderModel>>;

  @Select(AldState.GarageVisitRequest)
  GarageVisitRequest$: Observable<Models.Response<GarageVisitsModels.GarageVisitRequestModel>>;

    constructor(
        private formBuilder: FormBuilder,
        public router: Router,
        public authenticationService: AuthenticationService,
        public store: Store,
        public helperService: HelperService,
        public environmentService: EnvironmentService,
        public changeDetectorRef: ChangeDetectorRef,
        public bannerService: BannerService
    ) {

      super(helperService, environmentService, changeDetectorRef, router, authenticationService, store);
    }

  ngOnInit() {

    super.ngOnInit();

    this.subscription.add(this.TyreOrders$.subscribe((data) => {
      if (data && data.Success) {
        this.orders = data.Items;
        }
    }));

    this.subscription.add(this.GarageVisitRequest$.subscribe((data) => {

      if (data && data.RequestSignature == this.requestGarageVisitRequest.RequestSignature && data.Success) {

        this.requestGarageVisitRequest.End();

        this.onHome();
      }
    }));


    }


  public onUserAuthenitcate() {

    if (this.currentUser && this.currentUser.CarId) {

      this.requestGet = new Models.RequestModel(this.currentUser.CarId);

      this.store.dispatch(new AldActions.TyreOrdersGet(this.requestGet));
    }
  };

  onTyreOrderVisit(TyreOrder: TyreOrderModels.TyreOrderModel) {
    if (this.currentUser) {
      this.router.navigate(['/tyre-order-visit', TyreOrder.OrderId]);
    }
  }

  onDepositeVisitRequest(Deposite: TyreOrderModels.TyreOrderModel) {
    if (this.currentUser) {

      this.requestGarageVisitRequest.Begin();

      this.requestGarageVisitRequest.Item = Deposite;

      this.store.dispatch(new AldActions.GarageVisitRequestForTyreOrder(this.requestGarageVisitRequest));
    }
  }

  public onSummary() { }
}
